import { render, staticRenderFns } from "./ScrollingDocument.vue?vue&type=template&id=ce7fa46e&"
import script from "./ScrollingDocument.vue?vue&type=script&lang=js&"
export * from "./ScrollingDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Intersect,Scroll})
